import styled from 'styled-components';
import { white, contiOrange } from '../../style/colors';

export const Button = styled.button`
  position: fixed;
  bottom: 30px;
  right: 30px;
  padding: 16px 24px;
  background: ${contiOrange};
  color: ${white};
  border: none;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(255, 165, 0, 0.4);
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 1000;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: ${props => props.visible ? 1 : 0};
  visibility: ${props => props.visible ? 'visible' : 'hidden'};
  transform: ${props => props.visible ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.9)'};

  &:hover {
    background: #ff8c00;
    box-shadow: 0 6px 28px rgba(255, 165, 0, 0.5);
    transform: translateY(-2px) scale(1.05);
  }

  &:active {
    transform: translateY(0) scale(0.98);
  }

  i {
    font-size: 22px;
    animation: ${props => props.pulse ? 'pulse 2s infinite' : 'none'};
  }

  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
  }

  @media (max-width: 768px) {
    bottom: 20px;
    right: 20px;
    padding: 14px 20px;
    font-size: 14px;

    i {
      font-size: 20px;
    }
  }
`;

export const Badge = styled.span`
  background: ${white};
  color: ${contiOrange};
  border-radius: 50%;
  min-width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  padding: 0 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);

  @media (max-width: 768px) {
    min-width: 24px;
    height: 24px;
    font-size: 12px;
  }
`;

